import samsungLogoBlack from "../../../../images/samsung-logo-black.svg";
import mcslogo from "../../../../images/mcs-logo-v2-v2.svg";
import ViewBase from "../../view-base.view";
import loginModel from "../../../models/login.model";
import profileModel from "../../../models/profile.model";
import navigationModel from "../../../models/navigation/navigation.model";
import globalConfig from "../../../config/global-variables";
import languagesStorage from "../../../storage/languages.storage";
import { Spinner } from "construct-ui";

export default function SamsungAccountAuthSelectUserView() {
  ViewBase.call(this);

  let hasLoginError = false
  let isLoggingIn = false
  let selectedUserId = ''
  let loginUserOptions = []
  let isGettingUsers = false

  const getLoginDetails = () => {
    return Promise.allSettled([getLanguageData(), getProfile(), getActiveMenuList()]);
  }
  const getLanguageData = () => {
    if (globalConfig.LanguageData == null) {
      return languagesStorage.openDatabase(globalConfig.LanguageDB);
    }
    return null;
  }
  const getProfile = () => {
    return profileModel.getProfile()
      .catch((error) => {
        this.handleError(error);
      })
  }
  const getActiveMenuList = () => {
    return navigationModel.getActiveMenuList()
      .catch(error => {
        this.handleError(error);
      })
  }
  const redirect = (hasAgreedToEULA) => {
    if (hasAgreedToEULA.toUpperCase() === 'Y') {
      this.routeTo('/home');
    } else {
      this.routeTo('/agreement');
    }
  }

  const loginWithSelectedUser = (e) => {
    this.showLoading()

    selectedUserId = e.target.value
    if (!selectedUserId) return
    const body = {
      state: m.route.param('state'),
      userID: selectedUserId,
      systemType: 0
    }
    loginModel.loginWithSpecificUserID(body)
      .then((result) => {
        if (result.mobileSuccessLoginLink) {
          this.routeTo(result.mobileSuccessLoginLink)
        }
        else {
          return getLoginDetails()
            .then(() => { redirect(result.agreementYN) });
        }
      }).finally(() => this.hideLoading())
  }

  let getUsers = () => {
    isGettingUsers = true
    const firstOption = {
      userID: "",
      name: this.getText("LT00000010", "Choose...")
    }

    selectedUserId = ''
    loginUserOptions = []
    loginUserOptions.push(firstOption)

    const body = {
      state: m.route.param('state')
    }
    loginModel.getUsersViaSamsungAccount(body)
      .then((result) => {
        
        loginUserOptions = [...loginUserOptions,
          ...result.map(userID => ({
            userID,
            name: userID
          }))
        ]
        if (result.length == 1) {
          this.showLoading()
          const body = {
            state: m.route.param('state'),
            userID: result[0],
            systemType: 0
          }
          loginModel.loginWithSpecificUserID(body)
          .then((result) => {
            if (result.mobileSuccessLoginLink) {
              this.routeTo(result.mobileSuccessLoginLink)
            }
            else {
              return getLoginDetails()
              .then(() => { redirect(result.agreementYN) });
            }
          }).finally(() => this.hideLoading())
        }else{
          isGettingUsers = false
        }
      })
      .catch((error) => {
        hasLoginError = true;
        isGettingUsers = false
        this.showErrorMessage("Samsung Account Login Error");
      })
  }
  return {
    oninit: function (vnode) {
      getUsers()
    },
    view: (vnode) => {
      return [
        isGettingUsers ?
        m(Spinner, {
          active: true,
          background: true,
          fill: true,
          size: 'xl',
        }):
        m(".container-login-form",
          m(".form-signin.m-3",
            [
              m("div", { "class": "pb-2" },
                m("div", { "class": "d-flex justify-content-start" },
                  m("img", { "class": "img-responsive samsung-logo-v2", "src": samsungLogoBlack })
                )
              ),
              m("div", { "class": "p-4" },
                m("div", { "class": "row" },
                  m("div", { "class": "d-flex justify-content-center" },
                    m("img", { "class": "img-responsive login-mcslogo-size", "src": mcslogo })
                  )
                )
              )
            ],
            [
              m(".d-flex", m(".w-100", m("h3.my-4.sign-in-style", "Sign In"))),
              hasLoginError &&
              m('.alert.alert-danger.alert-dismissible.fade.show.wrap-shadow[role="alert"]',
                [
                  m(
                    ".global-invalid-message.d-flex.justify-content-start",
                    [
                      m("i.bi.bi-exclamation-circle-fill.me-2"),
                      "Login Error",
                    ]
                  ),
                  m('button[type="button"].btn-close.x-close-sm', {
                    "data-bs-dismiss": "alert",
                    "aria-label": "Close",
                  }),
                ]
              ),
              m('.form-group.mb-4', m('label.form-label', this.getText("LT00000009", "User")),
                m('select.form-select[id="ddlUser"]', {
                  value: selectedUserId,
                  onchange: loginWithSelectedUser,
                  disabled: isLoggingIn,
                },
                  loginUserOptions.map(user => m('option', { value: user.userID }, user.name))
                )
              ),
              m('.d-flex.justify-content-center',
                m('button.btn.btn-secondary',
                  { onclick: () => { this.routeTo('/login') } }
                  ,
                  this.getText('LT00008096', 'Back'))
              )
            ]
          )
        ),
        this.getBaseViews()
      ]
    }
  }
}